import { createSlice } from '@reduxjs/toolkit';
import { get } from 'api/fetch';

const slice = createSlice({
  name: 'nomad_insurance/countries',
  initialState: {
    countries: []
  },
  reducers: {
    fetchCountriesRequest: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    fetchCountriesSuccess: (state, { payload }) => {
      state.isLoading = false;
      state.error = null;
      state.countries = payload;
    },
    fetchCountriesFailure: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
    }
  }
});

const { actions } = slice;

export const fetchCountries = () => async (dispatch) => {
  dispatch(actions.fetchCountriesRequest());

  try {
    const res = await get('/public/countries', { isNIOrchestrator: true });
    dispatch(actions.fetchCountriesSuccess(res?.countries));
  } catch (error) {
    dispatch(actions.fetchCountriesFailure());
  }
};

export default slice.reducer;
